<template>
  <div>
    <SideBar></SideBar>
    <Main></Main>
  </div>
</template>
<script>
import SideBar from "./SideBar";
import Main from "./Main";

export default {
  name: "Layout",
  components: { Main, SideBar }
};
</script>


// WEBPACK FOOTER //
// src/opr/pages/layout/index.vue